export class UserInfoModel {
  isSejami: boolean;
  nationalId: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  bankAccounts: BankAccountModel[];
  instrumentSettings: InstrumentSettingModel[];
  hasPassword: boolean;
  onboardedSections?: string;
}

export class InstrumentSettingModel {
  title: string;
  symbol: string;
  thumbnailLogoAddress?: string;
  editable?: boolean;
}

export class BankAccountModel {
  bankName: string;
  typeName: string;
  isDefault: boolean;
  shabaNumber: string;
  accountNumber: string;
  lastUpdateDateTimeUTC: string;
}
